import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-brown text-brand-sand py-12 px-6 text-center font-sans text-sm" data-id="element-35">
        <div className="max-w-4xl mx-auto opacity-70" data-id="element-36">
          <p className="mb-4" data-id="element-37">
            © {new Date().getFullYear()} Menopausia Sin Tabú. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-38">
            <button onClick={() => setActiveModal('privacy')} className="underline hover:text-white transition-colors" data-id="element-39">
              Política de Privacidad
            </button>
            <span data-id="element-40">|</span>
            <button onClick={() => setActiveModal('terms')} className="underline hover:text-white transition-colors" data-id="element-41">
              Términos y Condiciones
            </button>
          </div>
          <p className="max-w-2xl mx-auto text-xs leading-relaxed" data-id="element-42">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web y en el protocolo no pretende sustituir el consejo,
            diagnóstico o tratamiento médico profesional. Siempre busque el
            consejo de su médico u otro proveedor de salud calificado con
            cualquier pregunta que pueda tener sobre una condición médica.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-43">
        {activeModal && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-44">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-brand-brown/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-45" />

            {/* Modal */}
            <motion.div className="relative bg-brand-sand rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto z-10" initial={{
          scale: 0.95,
          y: 20
        }} animate={{
          scale: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} data-id="element-46">
              <div className="sticky top-0 bg-brand-sand border-b border-brand-surface flex items-center justify-between px-6 py-4 rounded-t-2xl" data-id="element-47">
                <h3 className="font-serif text-xl font-bold text-brand-brown" data-id="element-48">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-brand-surface transition-colors" data-id="element-49">
                  <XIcon className="w-5 h-5 text-brand-brown" data-id="element-50" />
                </button>
              </div>

              <div className="px-6 py-6 font-sans text-brand-brown/80 text-sm leading-relaxed space-y-4" data-id="element-51">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-52" /> : <TermsContent data-id="element-53" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="font-semibold text-brand-brown text-base" data-id="element-54">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-55">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-56">
        Recopilamos información personal que usted nos proporciona directamente,
        como su nombre, dirección de correo electrónico e información de pago al
        realizar una compra. También podemos recopilar información
        automáticamente cuando visita nuestro sitio, incluyendo su dirección IP,
        tipo de navegador y páginas visitadas.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-57">
        2. Uso de la Información
      </h4>
      <p data-id="element-58">
        Utilizamos su información para procesar sus pedidos, enviarle el
        contenido digital adquirido, comunicarnos con usted sobre su compra y
        mejorar nuestros servicios. No vendemos ni compartimos su información
        personal con terceros para fines de marketing.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-59">
        3. Protección de Datos
      </h4>
      <p data-id="element-60">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Todos los pagos se procesan a
        través de plataformas seguras y cifradas.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-61">
        4. Cookies
      </h4>
      <p data-id="element-62">
        Nuestro sitio web utiliza cookies para mejorar su experiencia de
        navegación. Puede configurar su navegador para rechazar cookies, aunque
        esto podría afectar la funcionalidad del sitio.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-63">
        5. Sus Derechos
      </h4>
      <p data-id="element-64">
        Usted tiene derecho a acceder, corregir o eliminar su información
        personal. Para ejercer estos derechos, contáctenos a través de nuestro
        correo electrónico de soporte.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-65">
        6. Contacto
      </h4>
      <p data-id="element-66">
        Si tiene preguntas sobre esta política de privacidad, puede contactarnos
        a través de nuestro correo electrónico de soporte.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="font-semibold text-brand-brown text-base" data-id="element-67">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-68">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-69">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, usted acepta estar sujeto a estos términos y condiciones. Si
        no está de acuerdo con alguna parte de estos términos, no debe utilizar
        nuestro sitio.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-70">
        2. Productos Digitales
      </h4>
      <p data-id="element-71">
        "Menopausia Sin Tabú" es un producto digital de contenido informativo y
        educativo. El acceso se otorga de forma inmediata tras la confirmación
        del pago. Los materiales son para uso personal y no pueden ser
        redistribuidos, copiados o compartidos sin autorización.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-72">
        3. Descargo de Responsabilidad Médica
      </h4>
      <p data-id="element-73">
        El contenido proporcionado es únicamente con fines informativos y
        educativos. No constituye consejo médico, diagnóstico ni tratamiento.
        Siempre consulte a su médico u otro profesional de salud calificado
        antes de realizar cambios en su dieta o estilo de vida, especialmente si
        toma medicamentos o tiene condiciones médicas preexistentes.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-74">
        4. Política de Reembolso
      </h4>
      <p data-id="element-75">
        Debido a la naturaleza digital e inmediata del producto, todas las
        ventas son finales. Sin embargo, si experimenta problemas técnicos para
        acceder al contenido, nuestro equipo de soporte le asistirá para
        resolver cualquier inconveniente.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-76">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-77">
        Todo el contenido, incluyendo textos, gráficos, logotipos y materiales
        descargables, es propiedad de Menopausia Sin Tabú y está protegido por
        las leyes de propiedad intelectual aplicables.
      </p>

      <h4 className="font-serif text-lg font-bold text-brand-brown mt-4" data-id="element-78">
        6. Modificaciones
      </h4>
      <p data-id="element-79">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos inmediatamente después de su
        publicación en el sitio web.
      </p>
    </>;
}